import * as go from 'gojs';
import {
  angleBinding,
  borderColorBinding,
  borderStyleBinding,
  borderWidthBinding,
  fillBinding,
  geometryStringBinding,
  locationBinding,
  lockedBindings,
  shadowBindings,
  sizeBinding,
  zOrderBindings,
} from '../common/utils/bindings';
import { realPorts, virtualPorts } from './../common/parts/port';
import { SHAPE_NODE_MAIN_SHAPE_NAME } from './config/part-names';

const $ = go.GraphObject.make;
const movable = true;
const resizable = true;
const rotatable = true;

export const shapeNodeTemplate = () =>
  $(
    go.Node,
    go.Node.Spot,
    {
      isShadowed: true,
      resizeObjectName: SHAPE_NODE_MAIN_SHAPE_NAME,
      selectionObjectName: SHAPE_NODE_MAIN_SHAPE_NAME,
      locationObjectName: SHAPE_NODE_MAIN_SHAPE_NAME,
      isLayoutPositioned: false,
      locationSpot: go.Spot.TopLeft,
      toolTip: null,
      rotationSpot: go.Spot.Center,
      movable,
      resizable,
      rotatable,
    },
    shape(),
    locationBinding(),
    angleBinding(),
    ...lockedBindings({ movable, resizable, rotatable }),
    ...shadowBindings(),
    ...zOrderBindings(),
    ...virtualPorts(),
    ...realPorts(),
  );

const shape = () =>
  $(
    go.Shape,
    {
      name: SHAPE_NODE_MAIN_SHAPE_NAME,
    },
    geometryStringBinding(),
    fillBinding(),
    sizeBinding(),
    borderColorBinding(),
    borderWidthBinding(),
    borderStyleBinding(),
  );
